import type { UserInfo } from '@/types/auth'
/**
 * Role utility functions
 * Provides helper functions for safely handling user roles
 */
import { UserRole } from '@/types/auth'

/**
 * Safely get user role with fallback to GUEST
 * @param userInfo User information object
 * @param isLoggedIn Whether user is logged in
 * @param hasToken Whether user has a valid token
 * @returns Safe user role, defaults to GUEST if invalid
 */
export function getSafeUserRole(
  userInfo: UserInfo | null | undefined,
  isLoggedIn: boolean,
  hasToken: boolean,
): UserRole {
  // If not logged in or no token, return GUEST
  if (!isLoggedIn || !hasToken) {
    return UserRole.GUEST
  }

  // If no user info, return GUEST
  if (!userInfo) {
    return UserRole.GUEST
  }

  // Validate role exists and is a valid UserRole
  const role = userInfo.role
  if (role && Object.values(UserRole).includes(role as UserRole)) {
    return role as UserRole
  }

  // Default to USER if role is invalid but user is logged in
  console.warn('[roleUtils] Invalid user role detected, defaulting to USER:', role)
  return UserRole.USER
}
